module.exports = __webpack_public_path__ + "img/XFGL_zh.0a70b34b.png";